import SignupForm from '../../components/user/forms/SignupForm';
import MainLayout from '../../layout/mainLayout';

function SignupPage() {
  return (
    <MainLayout>
      <SignupForm />
    </MainLayout>
  );
}

export default SignupPage;
